import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class PreviousMeetingsWidgetPlaceholderCompetitorProps extends BaseProps {}

export const PreviousMeetingsWidgetPlaceholderCompetitor = (props: PreviousMeetingsWidgetPlaceholderCompetitorProps) => {
  return (
    <div className={'previous-meetings-widget-placeholder-header-competitor'}>
      <div className={'previous-meetings-widget-placeholder-header-competitor-logo'}/>
      <div className={'previous-meetings-widget-placeholder-header-competitor-name'}/>
    </div>
  );
}
